import type { IListingBanner, IListingBannerResponse } from 'types';

export function parseBanner(banner: IListingBannerResponse): IListingBanner | undefined {
  if (!banner) return undefined;

  const {
    position,
    image: imageDesktop,
    imageResponsive,
    type,
    url,
    newTab,
    // temporarily removed
    // displayOnMobile,
    name,
  } = banner || {};

  return {
    position: position - 1,
    type,
    href: url,
    newTab,
    name,
    image: {
      desktop: { ...(imageDesktop || {}), default: imageDesktop?.jpg },
      responsive: { ...(imageResponsive || {}), default: imageResponsive?.jpg },
    },
    // temporarily removed
    // responsiveProps: {
    //   hidden: !displayOnMobile
    // },
    desktopProps: {},
  };
}
